import script from "./MonthPickerDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthPickerDialog.vue?vue&type=script&setup=true&lang=ts"

import "./MonthPickerDialog.vue?vue&type=style&index=0&id=6371cac4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6371cac4"]])

export default __exports__